import { createComponent } from '@carvana/merch-components';

export const DisclaimerParagraph = createComponent('p', {
  className:
    'max-w-[1056px] px-24 text-center text-text-weak t-body-xs sm:px-32'
});
